/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_After_LabelInputs */

const en_compare_event_groups_after_label = /** @type {(inputs: Compare_Event_Groups_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After:`)
};

const fr_compare_event_groups_after_label = /** @type {(inputs: Compare_Event_Groups_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Après :`)
};

const de_compare_event_groups_after_label = /** @type {(inputs: Compare_Event_Groups_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach:`)
};

const it_compare_event_groups_after_label = /** @type {(inputs: Compare_Event_Groups_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopo:`)
};

const ru_compare_event_groups_after_label = /** @type {(inputs: Compare_Event_Groups_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`После:`)
};

const es_compare_event_groups_after_label = /** @type {(inputs: Compare_Event_Groups_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Después:`)
};

const zh_cn2_compare_event_groups_after_label = /** @type {(inputs: Compare_Event_Groups_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后：`)
};

const ja_compare_event_groups_after_label = /** @type {(inputs: Compare_Event_Groups_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`後：`)
};

const hi_compare_event_groups_after_label = /** @type {(inputs: Compare_Event_Groups_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाद में:`)
};

const pt_pt2_compare_event_groups_after_label = /** @type {(inputs: Compare_Event_Groups_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois:`)
};

/**
* | output |
* | --- |
* | "After:" |
*
* @param {Compare_Event_Groups_After_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_after_label = /** @type {((inputs?: Compare_Event_Groups_After_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_After_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_after_label(inputs)
	if (locale === "de") return de_compare_event_groups_after_label(inputs)
	if (locale === "it") return it_compare_event_groups_after_label(inputs)
	if (locale === "ru") return ru_compare_event_groups_after_label(inputs)
	if (locale === "es") return es_compare_event_groups_after_label(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_after_label(inputs)
	if (locale === "ja") return ja_compare_event_groups_after_label(inputs)
	if (locale === "hi") return hi_compare_event_groups_after_label(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_after_label(inputs)
	return en_compare_event_groups_after_label(inputs)
});